import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import * as api from '../api/api';
import { pickErrorMessage } from '../lib/apiHelpers';
import { PageHeader, Card, CardBody, ErrorBanner } from '../components/PageChrome';
import { DataTable } from '../components/DataTable';
import { IconPencil } from '../components/Icons';

export default function Brands() {
  const [rows, setRows] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError('');
      try {
        const data = await api.listBrands({ limit: 100 });
        if (!cancelled) setRows(data?.items || []);
      } catch (err) {
        if (!cancelled) setError(pickErrorMessage(err));
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const columns = [
    { key: 'name', label: 'Brand' },
    {
      key: 'status',
      label: 'Status',
      render: (r) => (
        <span className={`badge ${r.status === 'active' ? 'text-bg-success' : 'text-bg-secondary'}`}>
          {r.status}
        </span>
      ),
    },
    { key: 'couponQuota', label: 'Quota', render: (r) => r.couponQuota ?? '—' },
    { key: 'email', label: 'Email' },
    {
      key: 'coupons',
      label: 'Coupons',
      width: 'fit-content',
      render: (r) => (
        <Link
          to={`/coupons?brandId=${encodeURIComponent(r.id)}`}
          className="btn btn-sm btn-outline-secondary"
        >
          View coupons
        </Link>
      ),
    },
    {
      key: 'actions',
      label: '',
      width: '80px',
      render: (r) => (
        <Link to={`/brands/${r.id}`} className="btn-table-icon btn-table-icon--edit" title="Edit">
          <IconPencil size={16} />
        </Link>
      ),
    },
  ];

  return (
    <>
      <PageHeader
        title="Brands"
        subtitle="Manage brand accounts on the Verify Goods platform."
        actions={<Link to="/brands/new" className="btn btn-primary">Add brand</Link>}
      />
      <ErrorBanner message={error} />
      <Card className="shadow-sm">
        <CardBody>
          <DataTable
            columns={columns}
            rows={rows}
            loading={loading}
            emptyTitle="No brands yet"
            emptyDescription="Create a brand to start generating coupon codes."
            rowKey="id"
          />
        </CardBody>
      </Card>
    </>
  );
}
